import type { BariPreSecretarialAssistantMedScreeningReportBaseData } from '@common/validation/customControls/bariPre/bariPreSecretarialAssistantMedScreeningReport/bariPreSecretarialAssistantMedScreeningReportData';

export const initialData: BariPreSecretarialAssistantMedScreeningReportBaseData = {
    alcohol: null,
    alcohol_aantal_eenheden_per_week: null,
    alcohol_toelichting: null,
    bloeddruk_diastolisch: null,
    bloeddruk_gemeten: null,
    bloeddruk_systolisch: null,
    buikomvang: null,
    datum_screening: null,
    drugs: null,
    drugs_toelichting: null,
    gewicht_in_kg: null,
    hoogste_gewicht_in_kg: null,
    lengte_in_cm: null,
    pols: null,
    saturatie: null,
};
